document.addEventListener("DOMContentLoaded", function(event) {
window.onload = function() {

TweenMax.staggerFrom('.form-actions',2,{
  scale:0.5,
  opacity:0,
  delay:0.5,
  ease:Elastic.easeOut
},0.2);


    };
});